import { Link } from 'react-router-dom';
import LogoImages from '@shared/assets/images/logos';
import { ROUTES } from '@shared/configs/constants';

const AdminFooter = () => {
    const navLinks = [
        { label: '利用ガイド', href: ROUTES.usageGuide.href },
        { label: '個人情報保護方針', href: ROUTES.privacyPolicy.href },
        { label: '利用規約', href: ROUTES.termsOfService.href }
    ];

    return (
        <footer className='bg-section-footer'>
            <div className='container mx-auto px-4 py-[40px]'>
                <div className='ml-[-24px] mb-[24px] lg:mb-[48px]'>
                    <Link to='/'>
                        <img src={LogoImages.logoWhite} alt='じほう電子コンテンツストア' className='h-[50px]' />
                    </Link>
                </div>

                <div>
                    <div className='flex flex-col sm:flex-row sm:flex-wrap items-start sm:items-center gap-[12px] sm:gap-[20px] lg:gap-[40px] xl:gap-[60px] py-[7px]'>
                        {navLinks.map((link, _) => (
                            <Link
                                key={link.href}
                                to={link.href}
                                className='font-normal text-[14px] leading-[26px] text-white hover:text-primary transition-colors'
                            >
                                {link.label}
                            </Link>
                        ))}
                    </div>
                </div>

                <div className='h-[1px] w-full bg-[#D9D9D91A] my-[24px]' />

                <div className='flex flex-col sm:flex-row items-start sm:items-center justify-between gap-[16px]'>
                    <p className='font-normal text-[14px] leading-[26px] text-white'>
                        Copyright © 2025 Jiho Inc. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default AdminFooter;
